<template>
    <v-card class="rounded-xl">
        <v-card-title class="headline primary white--text d-flex justify-space-between align-center">
            <span>Variantes de Etiquetas Cliente: {{ customerTemplate?.CardName }}</span>
            <v-btn icon dark @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
            <s-crud v-if="isReady" ref="gridTemplateVariants" title="Detalle de Variantes" add edit remove
                :config="config" :filter="filter" @save="save($event)" @rowSelected="rowSelected($event)" searchInput
                height="50dvh">
                <template scope="props">
                    <v-container fluid class="pa-2">
                        <v-row dense>
                            <!-- Cultivo -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition label="Cultivo" :def="1173" v-model="props.item.TypeCrop"
                                    @change="onCultiveChange($event, props.item)"
                                    @getDataInitial="cropItems = $event" />
                            </v-col>

                            <!-- Variedad -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-variety full clearable
                                    :cultiveID="props.item.TypeCrop ? Number(props.item.TypeCrop) : 0"
                                    v-model="props.item.VrtID" label="Variedad"
                                    @getDataInitial="varietyItems = $event" />
                            </v-col>

                            <!-- Tipo Cultivo -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition label="Tipo Cultivo" clearable :def="1172"
                                    v-model="props.item.TypeCultive" @getDataInitial="cultiveItems = $event" />
                            </v-col>

                            <!-- Marca Caja -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select class="text-capitalize" clearable autocomplete label="Marca Caja"
                                    :items="uniqueBrands(props.item.TypeCrop)" item-text="Text" item-value="Value"
                                    :value="props.item.Brand" @change="onChangeBrandName($event, props.item)"
                                    placeholder="Seleccionar marca" id="sBrandNamePti" ref="sBrandNamePti" />
                            </v-col>
                        </v-row>
                    </v-container>
                </template>

                <template v-slot:Template="{ row }">
                    <v-btn @click="openZebraEditor(row)" small color="light" dark
                        class="rounded-lg text-none font-weight-bold" depressed>
                        <v-icon small class="mr-1">mdi-file-document-edit</v-icon>
                        Plantilla
                    </v-btn>
                </template>
            </s-crud>
        </v-card-text>


        <v-dialog v-if="modalEditorZebra" v-model="modalEditorZebra" fullscreen persistent>
            <zebra-editor :label-data="zebraEditorPropData" :show-save="true" @close="modalEditorZebra = false"
                @save-template="onSaveTemplate"></zebra-editor>
        </v-dialog>
    </v-card>
</template>

<script>
import _sPrfCustomerTemplateVariantService from "@/services/FreshProduction/PrfCustomerTemplateVariantService";
import _sPackingService from "@/services/FreshProduction/PackingService";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety.vue";
import ZebraEditor from "../CustomerTemplate/ZebraEditor.vue";

export default {
    name: "PrfCustomerTemplateVariant",
    components: { SSelectVariety, ZebraEditor },
    props: {
        ctmpId: {
            type: [Number, String],
            required: true
        },
        customerTemplate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedTemplateItem: null,
            modalEditorZebra: false,
            cultiveItems: [],
            varietyItems: [],
            SelectedBrandRow: [],
            cropItems: [],
            itemsMaterialBrands: [],
            filter: {
                CtmpID: this.ctmpId
            },
            config: {
                model: {
                    CtmpvID: "ID",
                    CtmpID: "int",
                    TypeCultive: "int",
                    VrtID: "int",
                    TypeCrop: "int",
                    Brand: "string",
                    SecStatus: "int",
                    Template: "Template"
                },
                service: _sPrfCustomerTemplateVariantService,
                headers: [
                    { text: "ID", value: "CtmpvID", width: 50 },
                    { text: "Cultivo", value: "TypeCropName" },
                    { text: "Variedad", value: "VrtName" },
                    { text: "Tipo Cultivo", value: "TypeCultiveName", align: 'center' },
                    { text: "Marca", value: "Brand", align: 'center' },
                    { text: "Plantilla", value: "Template", align: 'center', width: 120 },
                ]
            }
        };
    },
    computed: {
        isReady() {
            return this.ctmpId !== null && this.ctmpId !== undefined && this.ctmpId !== '';
        },
        zebraEditorPropData() {
            if (!this.selectedTemplateItem) return null;
            return {
                Id: `Variante-${this.selectedTemplateItem.CtmpID}-${this.selectedTemplateItem.CtmpvID}`,
                Template: this.selectedTemplateItem.Template
            };
        }
    },
    watch: {
        ctmpId(newId) {
            this.filter.CtmpID = newId;
            if (this.$refs.gridTemplateVariants) {
                this.$refs.gridTemplateVariants.refresh();
            }
        }
    },
    created() {
        this.Initialize();
    },
    methods: {
        Initialize() {
            this.loadMaterialBrands();
        },
        loadMaterialBrands() {
            const filter = {
                Search: '',
                TypeCrop: null,
                VrtID: null,
                TypeCultive: null,
                UwoStatus: 1 // @PackingLineStatus: ACTIVOS
            }
            _sPackingService.listMaterialBrand(filter, this.$fun.getUserID()).then(r => {
                this.itemsMaterialBrands = r.status == 200 ? r.data : [];
                // console.log("listMaterialBrand modal", r.data);
            }).catch(err => {
                console.error("Error al cargar marcas de material en modal:", err);
            });
        },
        uniqueBrands(TypeCrop) {
            if (!TypeCrop) return [];
            const list = [];
            const seen = new Set();
            (this.itemsMaterialBrands || []).forEach(x => {
                if (x.CropID == TypeCrop && x.Brand && !seen.has(x.Brand)) {
                    seen.add(x.Brand);
                    list.push({
                        Text: x.Brand,
                        Value: x.Brand
                    });
                }
            });
            return list;
        },
        onCultiveChange(cultiveID, item) {
            console.log("onCultiveChange modal:", cultiveID);
            item.Brand = null;
            item.VrtID = null;
        },
        onChangeBrandName(brandName, item) {
            console.log("onChangeBrandName modal:", brandName);
            if (!brandName) {
                item.Brand = null;
                return;
            }
            item.Brand = brandName;
        },
        rowSelected(item) {
            console.log("rowSelected", JSON.parse(JSON.stringify(item)));
            const target = Array.isArray(item) ? item[0] : item;
            if (target) {

                if (target.Brand) {
                    const brands = target.Brand.split(',').map(x => x.trim()).filter(Boolean);
                    const foundItems = this.itemsMaterialBrands.filter(b => brands.includes(b.Brand));
                    this.SelectedBrandRow = foundItems;

                } else {
                    this.SelectedBrandRow = [];
                }
            }
        },
        save(item) {
            if (!item.TypeCrop) {
                this.$fun.alert("Debe seleccionar un Cultivo.", "warning");
                return;
            }
            if (!item.Brand) {
                this.$fun.alert("Debe seleccionar una Marca Caja.", "warning");
                return;
            }

            // Get descriptions for each selected value to keep local UI names in sync
            const cropDesc = (this.cropItems || []).find(x => x.DedValue == item.TypeCrop)?.DedDescription || '';
            const varietyDesc = (this.varietyItems || []).find(x => x.VrtID == item.VrtID)?.VrtDescription || '';
            const cultiveDesc = (this.cultiveItems || []).find(x => x.DedValue == item.TypeCultive)?.DedDescription || '';

            item.TypeCropName = cropDesc;
            item.VrtName = varietyDesc;
            item.TypeCultiveName = cultiveDesc;

            item.CtmpID = this.ctmpId;
            item.SecStatus = 1;
            item.UsrCreateID = this.$fun.getUserID()

            if (!(item.CtmpvID > 0) && !item.Template) {
                item.Template = this.customerTemplate ? this.customerTemplate.Template : null;
            }

            console.log("Save")
            console.log(JSON.parse(JSON.stringify(item)));

            if (typeof item.save === 'function') {
                item.save();
            } else {
                _sPrfCustomerTemplateVariantService.save(item, this.$fun.getUserID()).then(() => {
                    this.$fun.alert("Variante guardada correctamente.", "success");
                    if (this.$refs.gridTemplateVariants) {
                        this.$refs.gridTemplateVariants.refresh();
                    }
                }).catch(err => {
                    console.error("Error al guardar variante:", err);
                    this.$fun.alert("Error al guardar la variante.", "error");
                });
            }
        },
        openZebraEditor(item) {
            this.selectedTemplateItem = item;
            this.modalEditorZebra = true;
        },
        onSaveTemplate(jsonString) {
            this.modalEditorZebra = false;
            if (this.selectedTemplateItem) {
                this.selectedTemplateItem.Template = jsonString;
                this.save(this.selectedTemplateItem);
            }
        },
    }
};
</script>

<style scoped></style>
